

<template>
  <GravManagerWrapper :id="id" :componentName="componentName" :properties="props">
    <component :is="AccountToAccount" v-bind="{ style: $attrs.style, ...changableProps }">
      <template v-for="slotName in Object.keys($slots)" #[slotName]="slotProps">
        <slot :name="slotName" v-bind="slotProps" />
      </template>
    </component>
  </GravManagerWrapper>
</template>

<script setup lang="ts">
import GravManagerWrapper from './GravManagerWrapper.vue';

import { AccountToAccountProps } from './AccountToAccount.ts';
import AccountToAccount from './AccountToAccount.vue';

import { useChangableProps } from '@/composables/useChangableProps';

const componentName = 'ui-account-to-account';
const $slots = defineSlots<Record<string, unknown>>();

const props = defineProps<AccountToAccountProps>();
const changableProps = useChangableProps(componentName, props);

</script>
